import React from "react";
import { m } from "kremling";

export function EmptyCell({ isDisabled }) {
  return <span className={m("cp-table-cell-disabled", isDisabled)}>—</span>;
}
